import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "section columns" }
const _hoisted_2 = { class: "ul-box !m-0" }
const _hoisted_3 = { class: "section columns" }
const _hoisted_4 = { class: "mb-rem2" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "ul-box clear-both" }
const _hoisted_7 = { class: "wrong" }
const _hoisted_8 = { class: "ul-box" }
const _hoisted_9 = { class: "wrong" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "section" }
const _hoisted_13 = { class: "ul-box" }
const _hoisted_14 = { class: "wrong" }
const _hoisted_15 = { class: "section" }
const _hoisted_16 = {
  id: "invisalign-cena",
  style: {"display":"block"}
}
const _hoisted_17 = { class: "text-black" }

import ArticleModalContent from '@/components/ArticleModalContent.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Frenulotomija',
  emits: ["close", "navigate"],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_a_info_panel = _resolveComponent("a-info-panel")!
  const _component_a_circular_image = _resolveComponent("a-circular-image")!

  return (_openBlock(), _createBlock(ArticleModalContent, {
    title: _ctx.$t('articles.frenulotomija.title'),
    cover: require('@/assets/covers/frenulotomija.jpg'),
    "cover-offset": ['20%', '50%'],
    "close-button-dark": true,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createVNode(_component_a_info_panel, {
            icon: require('@/assets/png-icons/bulb.png'),
            class: "mb-rem2 narrow-text"
          }, {
            default: _withCtx(() => [
              _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.frenulotomija.infoPanelBold')), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('articles.frenulotomija.infoPanelBody')), 1)
            ]),
            _: 1
          }, 8, ["icon"]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('articles.frenulotomija.vezListTitle')), 1),
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$tm('articles.frenulotomija.vezList'), (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: String(item)
                }, _toDisplayString(item), 1))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("i", {
            class: "side-image float-left ml-rem1 mt-rem1 mb-rem1 !bg-contain desktop-only",
            style: _normalizeStyle({
                        backgroundImage: `url(${require(
                            `@/assets/frenulums${_ctx.$i18n.locale === 'en' ? '-en' : ''}.jpg`,
                        )})`,
                    })
          }, null, 4)
        ])
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('articles.frenulotomija.podjezicnaTitle')), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("i", {
            class: "side-image float-right ml-rem1 mt-rem1 mb-rem1 !bg-contain mobile-only",
            style: _normalizeStyle({
                        backgroundImage: `url(${require(
                            `@/assets/frenulums${_ctx.$i18n.locale === 'en' ? '-en' : ''}.jpg`,
                        )})`,
                    })
          }, null, 4),
          _createElementVNode("p", {
            innerHTML: _ctx.$t('articles.frenulotomija.podjezicnaP1')
          }, null, 8, _hoisted_5),
          _createElementVNode("p", null, [
            _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.frenulotomija.podjezicnaP2Bold')), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('articles.frenulotomija.dojenckiListTitle')), 1),
            _createElementVNode("ul", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$tm('articles.frenulotomija.dojenckiList'), (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: String(item)
                }, _toDisplayString(item), 1))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('articles.frenulotomija.otrokListTitle')), 1),
            _createElementVNode("ul", _hoisted_9, [
              _createElementVNode("li", null, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('articles.frenulotomija.otrokList[0]')), 1)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('articles.frenulotomija.otrokList[1]')), 1)
              ])
            ])
          ]),
          _createElementVNode("p", {
            innerHTML: _ctx.$t('articles.frenulotomija.podjezicnaP3')
          }, null, 8, _hoisted_10),
          _createElementVNode("p", {
            innerHTML: _ctx.$t('articles.frenulotomija.podjezicnaP4')
          }, null, 8, _hoisted_11)
        ])
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('articles.frenulotomija.zgornjaTitel')), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.frenulotomija.zgornjaiP')), 1),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('articles.frenulotomija.zgornjaListTitle')), 1),
          _createElementVNode("ul", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$tm('articles.frenulotomija.zgornjaList'), (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: String(item)
              }, _toDisplayString(item), 1))
            }), 128))
          ])
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("hr", null, null, -1)),
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('articles.frenulotomija.potekTitle')), 1),
        _createVNode(_component_a_circular_image, {
          image: require('@/assets/laser-sirolaser-blue.jpg')
        }, null, 8, ["image"]),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.frenulotomija.potekP1')), 1),
        _createElementVNode("p", null, [
          _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.frenulotomija.potekP2Bold')), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('articles.frenulotomija.potekP2body')), 1)
        ])
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("h2", _hoisted_16, [
          _createTextVNode(_toDisplayString(_ctx.$t('articles.frenulotomija.cenikTitlePre')) + " ", 1),
          _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("b", _hoisted_17, _toDisplayString(_ctx.$t('articles.frenulotomija.cenikTitleBold')), 1)
        ]),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('articles.frenulotomija.cenikPre')), 1),
          _createElementVNode("b", {
            class: "internal-link",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('navigate', 'cenik', 'lasersko')))
          }, _toDisplayString(_ctx.$t('articles.frenulotomija.cenikLinkText')), 1),
          _createTextVNode(_toDisplayString(_ctx.$t('articles.frenulotomija.cenikPost')), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "cover"]))
}
}

})